import { mount } from "../utils";
import { FireMapTabs } from "../components";

mount(FireMapTabs, "fire_map_tabs");
